import { jsxs as t, jsx as n } from "react/jsx-runtime";
import { c as l } from "../clsx-OuTLNxxd.js";
import { B as d } from "../Badge-DlK8QV91.js";
import { a as v } from "../Tooltip-Db471qlE.js";
import '../Comparison.css';const C = "_comparisonContainer_8rctg_32", f = "_valuesContainer_8rctg_41", u = "_value_8rctg_41", $ = "_label_8rctg_49", b = "_leftBadge_8rctg_59", N = "_rightBadge_8rctg_63", w = "_progressBarContainer_8rctg_87", A = "_hasMiddleValue_8rctg_93", R = "_progressBar_8rctg_87", x = "_leftBar_8rctg_100", y = "_rightBar_8rctg_103", M = "_separatorContainer_8rctg_125", W = "_middleBadge_8rctg_138", j = "_badgeRightAligned_8rctg_151", a = {
  comparisonContainer: C,
  valuesContainer: f,
  value: u,
  label: $,
  leftBadge: b,
  rightBadge: N,
  progressBarContainer: w,
  hasMiddleValue: A,
  progressBar: R,
  leftBar: x,
  rightBar: y,
  separatorContainer: M,
  middleBadge: W,
  badgeRightAligned: j
}, q = (o, s = "Comparison") => {
  const i = o.reduce((e, c) => e + c, 0), r = 100;
  return i !== r ? (console.warn(`${s} component: The sum of values must equal ${r}. Current sum: ${i}`), !1) : !0;
}, k = ({
  comparisonLabel: o,
  leftValue: s,
  middleText: i = "DRAW",
  middleValue: r = 0,
  rightValue: e,
  tooltipText: c,
  ...g
}) => {
  if (!q([s, r, e]))
    return null;
  const _ = `${s}%`, h = `${r}%`, m = `${e}%`, p = r > 0, B = r > 0 && e <= 20;
  return /* @__PURE__ */ t(
    "div",
    {
      "aria-label": `${o} comparison bar with ${s}% on the left, ${r}% draw in the middle, and ${e}% on the right.`,
      className: a.comparisonContainer,
      "data-cxy-name": "comparison",
      role: "region",
      ...g,
      children: [
        /* @__PURE__ */ t("div", { className: a.valuesContainer, children: [
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-left", children: /* @__PURE__ */ t(d, { className: a.leftBadge, children: [
            s,
            "%"
          ] }) }),
          /* @__PURE__ */ t("div", { className: a.label, children: [
            o,
            " ",
            c && /* @__PURE__ */ n(v, { children: c })
          ] }),
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-right", children: /* @__PURE__ */ t(d, { className: a.rightBadge, children: [
            e,
            "%"
          ] }) })
        ] }),
        /* @__PURE__ */ t("div", { className: l(a.progressBarContainer, { [a.hasMiddleValue]: p }), children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.leftBar}`,
              "data-testid": "comparison-left-bar",
              style: { width: _ }
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: a.separatorContainer,
              "data-testid": "comparison-middle-bar",
              style: {
                width: r ? `${r}%` : void 0
              },
              children: r > 0 && /* @__PURE__ */ t(d, { className: l(a.middleBadge, { [a.badgeRightAligned]: B }), children: [
                i,
                " ",
                h
              ] })
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.rightBar}`,
              "data-testid": "comparison-right-bar",
              style: { width: m }
            }
          )
        ] })
      ]
    }
  );
};
export {
  k as Comparison
};
